<script>
import Base from '@/plans/ZOOM_ROOMS/config/base';
import { planTypes } from '@/common/constants';
import {
  isFromShoppingCart,
  isProductCanRemove,
  checkBasePlanCanRemove, isMeetingPlanDisabledByHasAddOn,
} from '@/views/config/shopping-cart/persist/plan-remove';
import audioUsCaMixin from '@/common/mixin/audio-us-ca-mixin';

export default {
  name: 'ZoomRoomsBuyNow',
  extends: Base,
  mixins: [audioUsCaMixin],
  computed: {
    licenseAlertDesc() {
      if (!this.zrAsBasePlan) return null;
      return this.mx_defLicenseAlertDesc;
    },
    canRmv() {
      if (isFromShoppingCart()) {
        return isProductCanRemove(this.selectedPlan);
      }
      if (isMeetingPlanDisabledByHasAddOn(planTypes.ZOOM_ROOMS)) {
        return false;
      }
      // remove logic: include standalone product && no other addons depend on zoom rooms
      const isBasePlanCanRemove = checkBasePlanCanRemove(this.selectedPlan);
      // workspace reservation with zr, visitor management with zr
      const fromQueryParam = this.$query?.from;
      if (
        fromQueryParam?.includes('zr') &&
        (fromQueryParam?.includes(planTypes.Work) || fromQueryParam?.includes(planTypes.VISITOR_MANAGEMENT))
      ) {
        return false;
      }
      return (!this.zrAsBasePlan || isBasePlanCanRemove) && this.$context.type !== this.planType;
    },
  },
};
</script>
